import { BaseService } from '@adgate/common/services/base-service';
import { Service } from '@angular/core';
import { environment } from '@env/environment';
import { ProductionRequestFilter } from '@adgate/modules/production/types/production-request-filter.type';
import { ProductionRequest } from '@adgate/modules/production/types/production-request.type';
import { ProductionVersionFilter } from '@adgate/modules/production/types/production-version-filter.type';
import { ProductionVersion } from '@adgate/modules/production/types/production-version.type';
import { ProductionRequestSample } from '../types/production-request-sample.type';

@Service()
export class ProductionService extends BaseService
{
    private baseServiceUrl = `${environment.baseServiceUrl}production`;

    getBaseServiceUrl()
    {
        return this.baseServiceUrl;
    }

    getProductionRequestOwners()
    {
        let url = `${this.baseServiceUrl}/getProductionRequestOwners`;
        return this.sendRequest(url, null, 'get');
    }

    getProductionRequestClients()
    {
        let url = `${this.baseServiceUrl}/getProductionRequestClients`;
        return this.sendRequest(url, null, 'get');
    }

    getProductionRequestShows()
    {
        let url = `${this.baseServiceUrl}/getProductionRequestShows`;
        return this.sendRequest(url, null, 'get');
    }

    getProductionRequests(filter: ProductionRequestFilter | null)
    {
        let url = `${this.baseServiceUrl}/getProductionRequests`;
        return this.sendRequest(url, filter, 'post');
    }

    deleteProductionRequest(requestId: number)
    {
        let url = `${this.baseServiceUrl}/deleteProductionRequest/${requestId}`;
        return this.sendRequest(url, null, 'delete');
    }

    updateProductionRequests(request: ProductionRequest)
    {
        let url = `${this.baseServiceUrl}/updateProductionRequest`;
        return this.sendRequest(url, request, 'post');
    }

    getProductionRequestSamples(requestId: number)
    {
        let url = `${this.baseServiceUrl}/getProductionRequestSamples/${requestId}`;
        return this.sendRequest(url, null, 'get');
    }

    updateProductionRequestSampleStatus(requestId: number, samples: ProductionRequestSample[])
    {
        let url = `${this.baseServiceUrl}/updateProductionRequestSampleStatus/${requestId}`;
        return this.sendRequest(url, samples, 'post');
    }

    getProductionVersions(filter: ProductionVersionFilter | null)
    {
        let url = `${this.baseServiceUrl}/getProductionVersions`;
        return this.sendRequest(url, filter, 'post');
    }

    deleteProductionVersion(versionId: number)
    {
        let url = `${this.baseServiceUrl}/deleteProductionVersion/${versionId}`;
        return this.sendRequest(url, null, 'delete');
    }

    updateProductionVersion(version: ProductionVersion)
    {
        let url = `${this.baseServiceUrl}/updateProductionVersion`;
        return this.sendRequest(url, version, 'post');
    }

    updateProductionRequestMasterCommercial(requestId: number, masterCommercialId: number, masterCommercialRefCode: string)
    {
        let payload: any = {
            masterCommercialId: masterCommercialId,
            masterCommercialRefCode: masterCommercialRefCode
        };

        let url = `${this.baseServiceUrl}/updateProductionRequestMasterCommercial/${requestId}`;
        return this.sendRequest(url, payload, 'post');
    }
}
